import type { ReactNode } from 'react'

import type { ModalProps } from './modal'
import { Modal } from './modal'

export type SimpleModalProps = Pick<
  ModalProps,
  'isOpen' | 'onClose' | 'className' | 'size' | 'children' | 'height' | 'fullScreenOnMobile'
> & {
  title?: ReactNode
  hideCloseIcon?: boolean
  contentClassName?: string
  renderFooter?: (props: { onClose: VoidFunction }) => ReactNode
}

export const SimpleModal = ({ children, title, renderFooter, ...props }: SimpleModalProps) => (
  <Modal {...props}>
    {config => (
      <>
        <Modal.Header {...props}>{title}</Modal.Header>
        <Modal.Content>
          {typeof children === 'function' ? children(config) : children}
        </Modal.Content>
        {renderFooter && <Modal.Footer>{renderFooter(config)}</Modal.Footer>}
      </>
    )}
  </Modal>
)
